import { createBrowserRouter } from "react-router-dom";
import {
  AddProvider,
  AllergyDerivatives,
  AppointmentReminderCard,
  CareGroupAdd,
  DiagnosedMedicalConditionDetails,
  DocumentDetails,
  EmergencyInformationCard,
  FamilyHistoryDetails,
  FoodDiaryCard,
  HealthRecordsLifestyle,
  HealthRecordsVitals,
  ProfileContact,
  ProfileDetails,
  ProfileGeneral,
  ProfileInsurance,
} from "./ui-components";
import LogIn from "./Login";
import HealthRecordsDocumentsPage from "./pages/HealthRecordsDocumentsPage";
import HealthRecordsDocumentPage from "./pages/HealthRecordsDocumentPage";
import HealthRecordsDocumentVideosPage from "./pages/HealthRecordsDocumentVideosPage";
import HealthRecordsDocumentImagesPage from "./pages/HealthRecordsDocumentImagesPage";
import HealthRecordsFamilyHistoryPage from "./pages/HealthRecordsFamilyHistoryPage";
import HealthRecordsMedicalConditionsPage from "./pages/HealthRecordsMedicalConditionsPage";
import HealthRecordsMedicationsPage from "./pages/HealthRecordsMedicationsPage";
import HealthRecordsDocumentPreviewPage from "./pages/hr/documents/mri/HealthRecordsDocumentPreviewPage";
import HealthProviderSeeAllProvidersPage from "./pages/HealthProviderSeeAllProvidersPage";
import OverallSymptomsViewPage from "./pages/quickActions/OverallSymptomsViewPage";
import OverallSymptomsAddPage from "./pages/quickActions/OverallSymptomsAddPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import FactSheetsPage from "./pages/quickActions/FactSheets";
import AboutMePage from "./components/profile/AboutMePage";
import InsurancesPage from "./components/profile/InsurancesPage";
import General from "./components/profile/General";
import ContactPage from "./components/profile/ContactPage";
import CareGroupsPage from "./components/careGroups/CareGroupsPage";
import CareGroupAddPage from "./components/careGroups/CareGroupsAddPage";
import DocumentAddPage from "./components/healthRecords/ImagingAndLabsAddPage";
import DocumentEditPage from "./components/healthRecords/ImagingAndLabsEditPage";
import DocumentViewPage from "./components/healthRecords/ImagingAndLabsPage";
import DocumentPreviewPage from "./components/healthRecords/ImagingAndLabsPreviewPage";
import CareGroupsEditPage from "./components/careGroups/CareGroupsEditPage";
import HealthProvidersPage from "./components/careProviders/HealthProvidersPage";
import HealthProvidersAddPage from "./components/careProviders/HealthProvidersAddPage";
import HealthProvidersEditPage from "./components/careProviders/HealthProvidersEditPage";
import CareGiversPage from "./components/careGivers/CareGiversPage";
import CareGiversAddPage from "./components/careGivers/CareGiversAddPage";
import ImmunizationPage from "./components/healthRecords/ImmunizationsPage";
import CareNotesPage from "./components/careNotes/CareNotesPage";
import CareNotesAddPage from "./components/careNotes/CareNotesAddPage";
import ProfileSummaryPage from "./components/profile/ProfileSummaryPage";
import MedicationsPage from "./components/healthRecords/MedicationsPage";
import HealthSummaryPage from "./components/healthRecords/HealthSummaryPage";
import SymptomsAddPage from "./components/healthRecords/SymptomsAddPage";
import SymptomsEditPage from "./components/healthRecords/SymptomsEditPage";
import SymptomsPage from "./components/healthRecords/SymptomsPage";
import MedicalConditionPage from "./components/healthRecords/MedicalConditionsPage";
import MedicalConditionAddPage from "./components/healthRecords/MedicalConditionAddPage";
import MedicalConditionEditPage from "./components/healthRecords/MedicalConditionEditPage";
import LifeStylePage from "./components/lifestyle/LifeStylePage";
import AllergiesPage from "./components/healthRecords/AllergiesPage";
import SwitchProfilePage from "./components/profile/SwitchProfilePage";
import HealthInsightsPage from "./components/healthInsights/HealthInsightsPage";
import AppointmentAddPage from "./components/healthInsights/appointmentContainer/AppointmentAddPage";
import FoodJournalAddPage from "./components/healthInsights/foodJournalsContainer/FoodJournalAddPage";
import FoodJournalEditPage from "./components/healthInsights/foodJournalsContainer/FoodJournalEditPage";
import FactsSheetPage from "./components/factsSheet/FactsSheetPage";
import FactsSheetDownload from "./components/factsSheet/FactsSheetDownloadPage";
import AppointmentEditPage from "./components/healthInsights/appointmentContainer/AppointmentEditPage";
import HealthProviderDetailsPage from "./components/careProviders/HealthProviderDetailsPage";
import EncounterAddPage from "./components/encounters/EncounterAddPage";
import EncounterEditPage from "./components/encounters/EncounterEditPage";
import ImmunizationsAddPage from "./components/healthRecords/ImmunizationsAddPage";
import ImmunizationsEditPage from "./components/healthRecords/ImmunizationsEditPage";
import MedicationsAddPage from "./components/healthRecords/MedicationsAddPage";
import MedicationsEditPage from "./components/healthRecords/MedicationsEditPage";
import AllergiesAddPage from "./components/healthRecords/AllergiesAddPage";
import AllergiesEditPage from "./components/healthRecords/AllergiesEditPage";
import MinorDependentsPage from "./components/minorDependents/MinorDependentsPage";
import MinorDependentsAddPage from "./components/minorDependents/MinorDependentsAddPage";
import FAQPage from "./components/kb/FAQPage";
import TermsOfServicePage from "./components/kb/TermsOfServicePage";
import PrivacyPolicyPage from "./components/kb/PrivacyPolicyPage";
import DisclosurePage from "./components/kb/DisclosurePage";
import CareGiversInvitePage from "./components/careGivers/CareGiversInvitePage";
import Settings from "./components/profile/Settings";
import VitalsEditPage from "./components/healthRecords/VitalsEditPage";
import VitalsAddPage from "./components/healthRecords/VitalsAddPage";
import VitalsPage from "./components/healthRecords/VitalsPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LogIn />,
    children: [
      {
        path: "/user/quick-actions/insights",
        element: <HealthInsightsPage />,
      },
      {
        path: "/user/quick-actions/appointment-reminder/add",
        element: <AppointmentAddPage />,
      },
      {
        path: "/user/quick-actions/appointment-reminder/:id/edit",
        element: <AppointmentEditPage />,
      },
      {
        path: "/user/quick-actions/insights/food-journal/add",
        element: <FoodJournalAddPage />,
      },
      {
        path: "/user/quick-actions/insights/food-journal/:id/edit",
        element: <FoodJournalEditPage />,
      },
      {
        path: "/user/quick-actions/food-diary",
        element: <FoodDiaryCard />,
      },
      {
        path: "/user/quick-actions/overall-symptoms",
        element: <SymptomsPage />,
      },
      {
        path: "/user/quick-actions/overall-symptoms/add",
        element: <SymptomsAddPage />,
      },
      {
        path: "/user/quick-actions/overall-symptoms/:id/edit",
        element: <SymptomsEditPage />,
      },
      {
        path: "/user/quick-actions/profile-summary",
        element: <ProfileSummaryPage />,
      },
      {
        path: "/user/quick-actions/health-summary",
        element: <HealthSummaryPage />,
      },
      {
        path: "/user/quick-actions/emergency-info",
        element: <FactsSheetDownload />,
      },
      {
        path: "/user/quick-actions/fact-sheets",
        element: <FactsSheetPage />,
      },
      {
        path: "/user/profile/about-me",
        element: <AboutMePage />,
      },
      {
        path: "/user/profile/contact",
        element: <ContactPage />,
      },
      {
        path: "/user/profile/insurance",
        element: <InsurancesPage />,
      },
      {
        path: "/user/profile/general",
        element: <General />,
      },
      {
        path: "/user/profile/settings",
        element: <Settings />,
      },
      {
        path: "/user/hr/lifestyle",
        element: <LifeStylePage />,
      },
      {
        path: "/user/hr/family-history",
        element: <HealthRecordsFamilyHistoryPage />,
      },
      {
        path: "/user/hr/family-history/add",
        element: <FamilyHistoryDetails />,
      },
      {
        path: "/user/hr/medical-problems",
        element: <MedicalConditionPage />,
      },
      {
        path: "/user/hr/medical-problems/add",
        element: <MedicalConditionAddPage />,
      },

      {
        path: "/user/hr/medical-problems/:id/edit",
        element: <MedicalConditionEditPage />,
      },
      {
        path: "/user/hr/allergies",
        element: <AllergiesPage />,
      },
      {
        path: "/user/hr/allergies/add",
        element: <AllergiesAddPage />,
      },
      {
        path: "/user/hr/allergies/:id/edit",
        element: <AllergiesEditPage />,
      },
      {
        path: "/user/hr/allergies/derivatives",
        element: <AllergyDerivatives />,
      },
      {
        path: "/user/hr/medications",
        element: <MedicationsPage />,
      },
      {
        path: "/user/hr/medications/add",
        element: <MedicationsAddPage />,
      },
      {
        path: "/user/hr/medications/:id/edit",
        element: <MedicationsEditPage />,
      },
      {
        path: "/user/hr/immunizations",
        element: <ImmunizationPage />,
      },
      {
        path: "/user/hr/immunizations/add",
        element: <ImmunizationsAddPage />,
      },
      {
        path: "/user/hr/immunizations/:id/edit",
        element: <ImmunizationsEditPage />,
      },
      {
        path: "/user/hr/vitals",
        element: <VitalsPage />,
      },
      {
        path: "/user/hr/vitals/add",
        element: <VitalsAddPage />,
      },
      {
        path: "/user/hr/vitals/:id/edit",
        element: <VitalsEditPage />,
      },
      {
        path: "/user/hr/documents",
        element: <DocumentViewPage />,
      },
      {
        path: "/user/hr/documents/add",
        element: <DocumentAddPage />,
      },
      {
        path: "/user/hr/documents/:id/edit",
        element: <DocumentEditPage />,
      },
      {
        path: "/user/hr/documents/:id/preview/:name",
        element: <DocumentPreviewPage />,
      },
      {
        path: "/user/hr/documents/:type",
        element: <HealthRecordsDocumentPage />,
      },
      {
        path: "/user/hr/documents/:type/videos",
        element: <HealthRecordsDocumentVideosPage />,
      },
      {
        path: "/user/hr/documents/:type/images",
        element: <HealthRecordsDocumentImagesPage />,
      },
      {
        path: "/user/hr/documents/:type/preview",
        element: <HealthRecordsDocumentPreviewPage />,
      },
      {
        path: "/user/hr/health-providers/:id",
        element: <HealthProviderDetailsPage />,
      },
      {
        path: "/user/hr/health-providers/:id/edit",
        element: <HealthProvidersEditPage />,
      },
      {
        path: "/user/hr/health-providers/add",
        element: <HealthProvidersAddPage />,
      },
      {
        path: "/user/hr/health-providers",
        element: <HealthProvidersPage />,
      },
      {
        path: "/user/hr/encounter/:providerId/add",
        element: <EncounterAddPage />,
      },
      {
        path: "/user/hr/encounter/:encounterId/edit",
        element: <EncounterEditPage />,
      },
      {
        path: "/user/hr/caregivers",
        element: <CareGiversPage />,
      },
      {
        path: "/user/hr/caregivers/add",
        element: <CareGiversAddPage />,
      },
      {
        path: "/user/hr/caregivers/invite",
        element: <CareGiversInvitePage />,
      },
      {
        path: "/user/kb/how-to-use",
        element: <ComingSoonPage />,
      },
      {
        path: "/user/kb/about",
        element: <ComingSoonPage />,
      },
      {
        path: "/user/kb/faq",
        element: <FAQPage />,
      },
      {
        path: "/user/kb/terms",
        element: <TermsOfServicePage />,
      },
      {
        path: "/user/kb/privacy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "/user/kb/disclosure",
        element: <DisclosurePage />,
      },
      {
        path: "/user/hr/care-groups",
        element: <CareGroupsPage />,
      },
      {
        path: "/user/hr/care-groups/add",
        element: <CareGroupAddPage />,
      },
      {
        path: "/user/hr/care-groups/:id/edit",
        element: <CareGroupsEditPage />,
      },
      {
        path: "/user/hr/care-notes",
        element: <CareNotesPage />,
      },
      {
        path: "/user/hr/care-notes/add",
        element: <CareNotesAddPage />,
      },
      {
        path: "/user/hr/fact-sheet",
        element: <ComingSoonPage />,
      },
      {
        path: "/user/hr/switch-profile",
        element: <SwitchProfilePage />,
      },
      {
        path: "/user/hr/minor-dependents",
        element: <MinorDependentsPage />,
      },
      {
        path: "/user/hr/minor-dependents/add",
        element: <MinorDependentsAddPage />,
      },
    ],
  },
]);
